const DsfNationalHomeNav = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_page" */ "./national/navTabs/navTabs"));
const DsfNationalFooter = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_page" */ "./national/footer"));
const DsfNationalHomeContentBtm = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_page" */ "./national/homeContentBottom"));
const NationalFixedLink = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_page" */ "./national/fixedLink"));
const DsfNationalNews = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/news"));
const DsfNationalNewsCarousel = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/newsCarousel"));
const NationalEconomicOperation = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/economicOperation"));
const NationalSurveyData = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/surveyData.vue"));
const NationalCountReport = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/countReport.vue"));
const NationalCountReportCn = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/countReportCn.vue"));
const NationalVisualizationCn = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/visualizationCn.vue"));
const NationalPublishSchedule = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/publishSchedule.vue"));
const NationalPublishScheduleCn = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/publishScheduleCn.vue"));
const NitonalOtherJumpBtns = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/otherJumpButton.vue"));
const DsfNationalDataview = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_home" */ "./national/home/dataview.vue"));
const DsfNationalTree = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_datatree" */ "./national/monthData/tree.vue"));
const DsfNationalArea = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_datapage" */ "./national/monthData/area1.vue"));
const DsfNationalTargetSelect = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_datapage" */ "./national/monthData/targetSelect.vue"));
const DsfNationalQuarterPicker = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_datapage" */ "./national/monthData/timeQuarterPicker.vue"));
const DsfNationalFilterTable = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_datapage" */ "./national/common/filterTable.vue"));
const DsfNationalTargetManage = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_datapage" */ "./national/common/targetManage.vue"));
const DsfNationalAddCollet = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_collection" */ "./national/common/addMyCollect.vue"));
const DsfNationalSevenCensuses = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_collection" */ "./national/home/sevenCensuses.vue"));
const DsfNationalMonitorListCn = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_collection" */ "./national/home/monitorListCn.vue"));
const DsfNationalEnFooter = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "project_national_page" */ "./national/enFooter"));

const components = {
  DsfNationalHomeNav,
  DsfNationalFooter,
  NationalEconomicOperation,
  NationalFixedLink,
  NationalCountReport,
  NationalCountReportCn,
  NationalVisualizationCn,
  NationalSurveyData,
  NationalPublishSchedule,
  NitonalOtherJumpBtns,
  DsfNationalHomeContentBtm,
  DsfNationalNews,
  DsfNationalDataview,
  DsfNationalTree,
  DsfNationalArea,
  DsfNationalTargetSelect,
  DsfNationalQuarterPicker,
  DsfNationalAddCollet,
  DsfNationalFilterTable,
  DsfNationalTargetManage,
  DsfNationalNewsCarousel,
  DsfNationalSevenCensuses,
  DsfNationalMonitorListCn,
  NationalPublishScheduleCn,
  DsfNationalEnFooter
};

function install(Vue) {
  for (var key in components) {
    let comp = components[key];
    let compName = comp.name || comp.__name || key;
    Vue.component(compName, comp);
    if (!window.$components["nationaldata"]) {
      window.$components["nationaldata"] = {};
    }
    window.$components["nationaldata"][compName] = comp;
  }
}
export default install;

export { install };
